/** @jsx h */
// @flow
import { h } from 'preact';
import { styled } from 'goober';

const LoaderContainer = styled('div')`
  width: fit-content;
  position: relative;
  margin: auto;
  .circularloader {
    border: 3px solid #ffffff !important;
    border-top: 3px solid transparent !important;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const CircularLoader = () => {
  return (
    <LoaderContainer>
      <div className='circularloader' />
    </LoaderContainer>
  );
};

export default CircularLoader;



// WEBPACK FOOTER //
// ./UiComponents/CircularLoader.js